import type { UcWorkflowStepSection } from '../../../lib/useCaseQueries';
import { UseCaseBand, UseCaseChipRow, UseCaseMedia, UseCaseSceneSlug } from '../primitives';

type UcWorkflowStepSectionProps = {
  data: UcWorkflowStepSection;
  tone: 'light' | 'dark';
};

export function UcWorkflowStepSection({ data, tone }: UcWorkflowStepSectionProps) {
  const mediaAlt = data.image?.alt ?? data.kicker ?? 'Workflow step image';
  const stepNum = parseInt(data.stepNumber ?? '0', 10);
  const isFlip = !Number.isNaN(stepNum) && stepNum % 2 === 0;

  return (
    <UseCaseBand tone={tone} id={`workflow-${data.stepNumber ?? data._key}`} className="uc-workflow-step">
      <UseCaseSceneSlug sceneNumber={data.sceneNumber} sceneLabel={data.sceneLabel} />
      <div className={`uc-work reveal${isFlip ? ' uc-work--flip' : ''}`}>
        <div className="uc-work-text">
          <div className="uc-work-step-meta">
            {data.stepNumber && <span className="uc-work-badge">{data.stepNumber}</span>}
            {data.kicker && <span className="uc-work-kicker">{data.kicker}</span>}
          </div>
          {data.heading && (
            <h3 className="uc-work-h">
              {data.heading}
              {data.headingAccent && (
                <>
                  {' '}
                  <span className="o">{data.headingAccent}</span>
                </>
              )}
            </h3>
          )}
          {data.body && <p className="uc-work-p">{data.body}</p>}
          <UseCaseChipRow chips={data.chips} style={data.chipStyle ?? 'tag'} />
        </div>
        {data.image && (
          <div className="uc-work-still" role="img" aria-label={mediaAlt}>
            <UseCaseMedia image={data.image} alt={mediaAlt} sizes="(max-width: 768px) 100vw, 50vw" />
          </div>
        )}
      </div>
    </UseCaseBand>
  );
}
